import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-sua-generic-dialog',
    templateUrl: './service-key-generic-dialog.component.html',
    styleUrls: ['./service-key-generic-dialog.component.scss']
})
export class ServiceKeyGenericDialogComponent {
    showSuccessContainer: boolean = false;
    constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, public matDialogRef: MatDialogRef<ServiceKeyGenericDialogComponent>) {

    }
    ngOnInit(){
        console.log(this.dialogData.status);
        if(this.dialogData.status == "success"){
            this.showSuccessContainer = true;
        }
    }
    cancel(){
        this.matDialogRef.close(false);
    }
}